var chunkMapping = {
	"src_App_jsx": [
		"webpack/container/remote/satellite/UWALoadScript"
	],
	"webpack_container_remote_observationsmanager_ObsMgnBuildCss": [
		"webpack/container/remote/observationsmanager/ObsMgnBuildCss"
	],
	"webpack_container_remote_satellite_buildCss": [
		"webpack/container/remote/satellite/buildCss"
	],
	"webpack_container_remote_satellite_Solutions": [
		"webpack/container/remote/satellite/Solutions"
	],
	"webpack_container_remote_satellite_GoogleMap": [
		"webpack/container/remote/satellite/GoogleMap"
	],
	"webpack_container_remote_satellite_Setting": [
		"webpack/container/remote/satellite/Setting"
	],
	"webpack_container_remote_satellite_Audio": [
		"webpack/container/remote/satellite/Audio"
	],
	"webpack_container_remote_satellite_Company": [
		"webpack/container/remote/satellite/Company"
	],
	"webpack_container_remote_satellite_Management": [
		"webpack/container/remote/satellite/Management"
	],
	"webpack_container_remote_satellite_AssetSynthesis": [
		"webpack/container/remote/satellite/AssetSynthesis"
	],
	"webpack_container_remote_satellite_PortfolioSynthesis": [
		"webpack/container/remote/satellite/PortfolioSynthesis"
	],
	"src_presentation_users-data_users_Users_jsx": [
		"webpack/container/remote/satellite/UWATabs",
		"webpack/container/remote/satellite/settingMenu"
	],
	"webpack_container_remote_satellite_DesignPageV3": [
		"webpack/container/remote/satellite/DesignPageV3"
	],
	"webpack_container_remote_satellite_PrediagV2": [
		"webpack/container/remote/satellite/PrediagV2"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/satellite/UWALoadScript": [
		"default",
		"./UWALoadScript",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/observationsmanager/ObsMgnBuildCss": [
		"default",
		"./ObsMgnBuildCss",
		"webpack/container/reference/observationsmanager"
	],
	"webpack/container/remote/satellite/buildCss": [
		"default",
		"./buildCss",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/Solutions": [
		"default",
		"./Solutions",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/GoogleMap": [
		"default",
		"./GoogleMap",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/Setting": [
		"default",
		"./Setting",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/Audio": [
		"default",
		"./Audio",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/Company": [
		"default",
		"./Company",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/Management": [
		"default",
		"./Management",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/AssetSynthesis": [
		"default",
		"./AssetSynthesis",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/PortfolioSynthesis": [
		"default",
		"./PortfolioSynthesis",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/UWATabs": [
		"default",
		"./UWATabs",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/settingMenu": [
		"default",
		"./settingMenu",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/DesignPageV3": [
		"default",
		"./DesignPageV3",
		"webpack/container/reference/satellite"
	],
	"webpack/container/remote/satellite/PrediagV2": [
		"default",
		"./PrediagV2",
		"webpack/container/reference/satellite"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}